<template>
  <DialogTemplateToolkit
    class-name="select-additional-field-type"
    :data-qa="'select-additional-field-type-dialog'"
    :dialog="opened"
    :title="$t('AdditionalFields.CreateField')"
    width="856"
    without_first_btn
    without_second_btn
    @close="$emit( 'close')">
    <template #backBtn>
      <sButton
        v-if="back_step"
        class="bold h7-text px-2"
        data-qa="back-btn"
        icon="long-arrow"
        icon-class="s-svg-icon-rotate-90"
        small
        type="text"
        @click="$emit( 'back')">
        {{ $t('Common.Back') }}
      </sButton>
    </template>
    <template #card-text>
      <div class="py-2">
        <div class="flex flex-between align-start">
          <div>
            <div class="select-additional-field-type__subtitle h5-headline">
              {{ $t('AdditionalFields.SelectFieldYouWantAdd') }}
            </div>
          </div>
          <sButton
            data-qa="btn-open-filter"
            icon="plus"
            type="text"
            @click="$emit('openExistingField')">
            {{ $t('AdditionalFields.SelectExistingField') }}
          </sButton>
        </div>
        <ul
          class="select-additional-field-type__list additional-types-list flex wrap justify-start pa-0 mt-4">
          <sIcon
            v-if="loading"
            class="my-5 mx-auto"
            color="var(--secondary__green_not_active)"
            size="30"
            spin
            type="loading"/>
          <FieldType
            v-for="(item, index) in additional_types"
            :key="index"
            class="additional-types-list__item mb-6"
            :class="['additional-types-list__item mb-6', {'mr-5': (index + 1) % 3}]"
            :item="item"
            @click="() => select(item)"/>
        </ul>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import FieldType from 'components/additional fields/FieldType.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { additionalFieldsMixin } from 'mixins'

export default {
  name: 'selectAdditionalFieldType',
  mixins: [additionalFieldsMixin],
  props: {
    back_step: {
      type: Boolean,
    },
    opened: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    }
  },
  methods: {
    select(item) {
      this.$emit( 'selectType', item )
    }
  },
  components: {
    FieldType,
    DialogTemplateToolkit
  }
}
</script>
<style lang="scss" scoped>
.select-additional-field-type {
  & &__title {
    line-height: 32px;
  }
}
</style>
